export const getCollapsedNavItemTextSx = (
  isCollapsed: boolean
): {
  opacity: number
  maxWidth: number
  marginLeft: number
  overflow: string
  whiteSpace: string
  minWidth: number
  transition: string
} => ({
  opacity: isCollapsed ? 0 : 1,
  maxWidth: isCollapsed ? 0 : 500,
  marginLeft: isCollapsed ? 0 : 1.5,
  overflow: "hidden",
  whiteSpace: "nowrap",
  minWidth: 0,
  transition: "opacity 0.2s ease, max-width 0.2s ease, margin-left 0.2s ease",
})
